import React, { useState } from 'react';
import {
  Box, Tabs, Tab, Typography,
} from '@mui/material';
import WorkflowTemplates from '../components/Automation/WorkflowTemplates';
import ScheduledFlows from '../components/Automation/ScheduledFlows';
import FlowExecutionTracker from './FlowExecutionTracker';
import AutomationRules from '../components/Automation/AutomationRules';
import PostBuilder from '../components/Automation/PostBuilder.jsx';

const tabs = [
  { label: 'Workflow Templates', value: 'templates' },
  { label: 'Scheduled Flows', value: 'schedules' },
  { label: 'Execution Tracker', value: 'tracker' },
  { label: 'Automation Rules', value: 'rules' },
  { label: 'Post Builder', value: 'postbuilder' },
];

function AutomationDashboard() {
  const [tab, setTab] = useState('templates');

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h3" sx={{ mb: 3 }}>Automation & Workflows</Typography>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ mb: 3 }}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs.map((t) => (
          <Tab key={t.value} label={t.label} value={t.value} />
        ))}
      </Tabs>
      {tab === 'templates' && <WorkflowTemplates />}
      {tab === 'schedules' && <ScheduledFlows />}
      {tab === 'tracker' && <FlowExecutionTracker />}
      {tab === 'rules' && <AutomationRules />}
      {tab === 'postbuilder' && <PostBuilder />}
    </Box>
  );
}

export default AutomationDashboard;
